window.recaptchaIds = {};

export const loadRecaptcha = (id = '') => {
  console.log('loadRecaptcha');
  const recap_loaded = document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]');

  if(!recap_loaded) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad&render=explicit';
    head.appendChild(script);
  }

  window.reCaptchaLoad = () => {
    const recaptchas = document.querySelectorAll('.g-recaptcha');
    recaptchas.forEach((elem, index) => {
      const reid = elem.getAttribute('data-reid');
      if (elem.dataset.sitekey && reid) {
        recaptchaIds[reid] = grecaptcha.render(elem, {
          'sitekey': elem.dataset.sitekey,
          'callback': (e) => onReCaptchaSuccess(id, e),
          'expired-callback': (e) => onExpiredCallback(id),
        });
      }
    });
  };

  window.onExpiredCallback = (id) => {
    document.dispatchEvent(new CustomEvent('g-captcha-expired', {
      bubbles: true,
      detail: {
        id,
      }
    }));
  }

  window.onReCaptchaSuccess = (id, e) => {
    document.dispatchEvent(new CustomEvent('g-captcha', {
      bubbles: true,
      detail: {
        id,
        captchaKey: e,
      }
    }));
  };
}



// WEBPACK FOOTER //
// ./src/js/components/load_recaptcha.js